<template>
  <div class="page">
    <h1>403 - Not Authorized</h1>
  </div>
</template>
<script>
export default {
  name: "Forbidden",
}
</script>